import { Channel } from './skill';

export enum OperationType {
    SkillCreated = 'skillCreated',
    SkillWithdrawn = 'skillWithdrawn',
    SkillStopped = 'skillStopped',
    SkillDeleted = 'skillDeleted',
    ReviewRequested = 'reviewRequested',
    ReviewCancelled = 'reviewCancelled',
    ReviewCancelledByUser = 'reviewCancelledByUser',
    ReviewApproved = 'reviewApproved',
    DeployRequested = 'deployRequested',
    DeployCompleted = 'deployCompleted',
    DeployRejected = 'deployRejected',
    SettingsReviewApproved = 'settingsReviewApproved',
    DeviceTestPrepared = 'deviceTestPrepared',
    DeviceTestStarted = 'deviceTestStarted',
    DeviceTestCompleted = 'deviceTestCompleted',

    SkillNominated = 'skillNominated',
    SkillNominationRotationCompleted = 'skillNominationRotationCompleted',
    SkillNominationRotationWithdrawn = 'skillNominationRotationWithdrawn',
}

export interface Operation<Comment = string> {
    id: string;
    type: OperationType;
    itemId?: string;
    itemName?: string;
    comment: Comment;
    createdAt: string;
}

export interface OperationEvent<Comment = string> {
    skillEntity: {
        id?: string;
        name: string;
        channel: Channel;
    };
    operation: Operation<Comment>;
}
